module.exports = __webpack_public_path__ + "static/img/lianxiwomen.19f7b1de.png";